/**
 * Free Shipping Progress Bar
 * 
 * Updates the free shipping progress bar when cart changes occur
 */
class FreeShippingProgress extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Initialize after DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupProgressBar());
    } else {
      this.setupProgressBar();
    }
  }

  setupProgressBar() {
    this.freeShippingThreshold = parseFloat(window.theme.settings.freeShippingLimit) * 100;
    this.progressBar = this.querySelector('[data-progress-bar]');
    this.messageElement = this.querySelector('.free-shipping-progress__message');
    
    if (!this.progressBar || !this.messageElement) return;

    // Set initial state
    this.updateProgressFromCart();
    
    // Listen for cart changes
    document.addEventListener('cart:refresh', this.updateProgressFromCart.bind(this));
    document.addEventListener('cart:updated', this.updateProgressFromCart.bind(this));
    
    // Trade theme specific events
    document.addEventListener('DOMContentLoaded', this.updateProgressFromCart.bind(this));
    document.addEventListener('cart:change', this.updateProgressFromCart.bind(this));
    
    // Additional events that might be triggered by the theme
    document.addEventListener('cart:build', this.updateProgressFromCart.bind(this));
    document.addEventListener('cart:updated', this.updateProgressFromCart.bind(this));
  }

  updateProgressFromCart() {
    // Fetch the current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => this.updateProgress(cart))
      .catch(error => console.error('Error fetching cart:', error));
  }

  updateProgress(cart) {
    if (!cart || !this.progressBar || !this.messageElement) return;
    
    const cartTotal = cart.total_price;
    const remainingAmount = this.freeShippingThreshold - cartTotal;
    const progressPercentage = Math.min((cartTotal / this.freeShippingThreshold) * 100, 100);
    
    // Update progress bar width with smooth transition
    this.progressBar.style.width = `${progressPercentage}%`;
    
    // Update message with fade effect to prevent layout jumps
    const formattedAmount = this.formatMoney(remainingAmount);
    const newMessage = cartTotal >= this.freeShippingThreshold 
      ? window.theme.strings.freeShippingEligible
      : window.theme.strings.freeShippingMessage.replace('{{ amount }}', `<strong>${formattedAmount}</strong>`);
    
    // Only update if the message has changed
    if (this.messageElement.innerHTML !== newMessage) {
      // Fade out, update text, fade in
      this.messageElement.style.opacity = '0';
      setTimeout(() => {
        this.messageElement.innerHTML = newMessage;
        this.messageElement.style.opacity = '1';
      }, 200);
    }
  }
  
  formatMoney(cents) {
    if (typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    
    const value = (cents / 100).toFixed(2);
    return `€${value}`;
  }
}

customElements.define('free-shipping-progress', FreeShippingProgress); 